import React, { useEffect, useState } from "react";

import Chrome from "IndividualApplication/Chrome";
import { enterInformationURL, individualVisionPlanURL } from "IndividualApplication/urls";
import { individualEligibleDental, individualEligibleVision, individualURLHelper, AnalyticsEvent } from "IndividualApplication/utils";
import { useHistory } from "react-router-dom";

import { useGetOrCreateApplicationQuery, useGetOfferedDentalPlansQuery, useUpdateIndividualApplicationMutation } from "../api";
import { IndividualDentalPlanCard } from "../Components/IndividualDentalPlanCard";
import { IndividualNavSection } from "../Components/IndividualNavSection";
import { SubBody } from "Cobalt/BodyText";
import Button from "Cobalt/Button";
import { Surface, SurfaceHeader, SurfaceSection } from "Cobalt/Surface";
import { Div } from "Common/HTML";

import makeBem from "Utils/makeBem";

const bem = makeBem("SelectIndividualPlanPage");

export const SelectDentalPlanPage = () => {
  const history = useHistory();
  const [dentalReady, setDentalReady] = useState(false);
  const { data: individualApplication, isLoading } = useGetOrCreateApplicationQuery({});
  const { data: dentalPlans = [] } = useGetOfferedDentalPlansQuery(
    {},
    {
      skip: !dentalReady,
    },
  );
  const [updateIndividualApplication] = useUpdateIndividualApplicationMutation();

  useEffect(() => {
    if (individualApplication) {
      if (!individualEligibleDental(individualApplication)) {
        history.push(individualURLHelper(individualVisionPlanURL));
      } else {
        setDentalReady(true);
        AnalyticsEvent("individual_dental_viewed");
      }
    }
  }, [individualApplication]);

  const resetIndividualDentalCart = async () => {
    await updateIndividualApplication({
      individualDentalPlanID: "",
      dependentEnrollmentDental: "",
    });

    history.push(individualURLHelper(individualEligibleVision(individualApplication) ? individualVisionPlanURL : enterInformationURL));
  };

  return (
    <Chrome title="Dental Plans">
      {!isLoading && individualApplication && (
        <Surface mt={5}>
          <SurfaceHeader>Add Individual Dental Plan</SurfaceHeader>
          <SurfaceSection>
            <Div className={bem("messageHeader")} mb={3}>
              <SubBody className={bem("messageHeader", "header")}>
                Since your employer does not offer dental insurance, you can enroll in an individual dental plan for yourself and your family.
              </SubBody>
              <Div className={bem("messageHeader", "linkButton")}>
                <Button onClick={resetIndividualDentalCart} color="tertiary">
                  Continue Without Dental
                </Button>
              </Div>
            </Div>
          </SurfaceSection>
          <SurfaceSection>
            {dentalPlans.map((plan, i) => (
              <Div key={plan.id} mt={i == 0 ? 0 : 4}>
                <IndividualDentalPlanCard mt={i == 0 ? 0 : 4} plan={plan} individualApplication={individualApplication} />
              </Div>
            ))}
          </SurfaceSection>
          <SurfaceSection>
            <IndividualNavSection page="dental" />
          </SurfaceSection>
        </Surface>
      )}
    </Chrome>
  );
};
